import React from "react";
import Control from "../../../../common/Controls/Control";
import useFormState from "../useFormState";
import BlockWrapper from "../../Layout/BlockWrapper";

const RCPROGlobalInfoInputs2 = () => {
  let { actions, errors, inputsConfig, formData } = useFormState();
  const inputState = formData.rcproGlobalInfo2Inputs;

  const updateRcproData = (e) => {
    const { name, value, type, checked } = e.target;
    const newFields = { [name]: value };

    actions.updateRCPROGlobalInfo2Inputs(newFields);

    //console.log("currentLocation", currentLocation);
  };

  return (
    <>
      <BlockWrapper>
        <div>
          <Control
            label={
              <>
                Êtes-vous <strong>actuellement assuré</strong> en Responsabilité
                Civile Professionnelle ?
              </>
            }
            type="btnList"
            name="possedeUneRC"
            value={inputState.possedeUneRC}
            change={updateRcproData}
            error={errors}
            labelClassname="w-100"
            inputGroupStyle={{ width: "100%" }}
            btnInline
            datas={inputsConfig.possedeUneRC.datas}
            dataIndex="id"
            dataLabel="name"
            required
          />
        </div>
        <div>
          <Control
            label={inputsConfig.resilieParAssureur.label}
            type="btnList"
            name="resilieParAssureur"
            value={inputState.resilieParAssureur}
            change={updateRcproData}
            error={errors}
            labelClassname="w-100"
            inputGroupStyle={{ width: "100%" }}
            btnInline
            datas={inputsConfig.resilieParAssureur.datas}
            dataIndex="id"
            dataLabel="name"
            required
          />
        </div>
        <div>
          <Control
            label={inputsConfig.changementProchainActivite.label}
            type="btnList"
            name="changementProchainActivite"
            value={inputState.changementProchainActivite}
            change={updateRcproData}
            error={errors}
            labelClassname="w-100"
            inputGroupStyle={{ width: "100%" }}
            btnInline
            datas={inputsConfig.changementProchainActivite.datas}
            dataIndex="id"
            dataLabel="name"
            required
          />
        </div>
        <div>
          <Control
            label={
              inputsConfig.dateNaissanceDirigeant?.label ||
              "Date de naissance du dirigeant"
            }
            type="date"
            name="dateNaissanceDirigeant"
            value={inputState.dateNaissanceDirigeant}
            change={updateRcproData}
            error={errors}
            labelClassname="w-100"
            inputGroupStyle={{ width: "100%" }}
            max={new Date().toISOString().split("T")[0]}
            required
          />
        </div>
      </BlockWrapper>
    </>
  );
};

export default RCPROGlobalInfoInputs2;
